import React from 'react';
import GlobalSettingsPanel from '../components/GlobalSettingsPanel';
import GlobalDocsPanel from '../components/GlobalDocsPanel';

export default function SettingsPage() {
  return (
    <div className="flex-1 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-text-primary mb-1" data-testid="settings-page-title">Settings</h1>
          <p className="text-text-secondary">Saver discounts, order email recipients, and business documents.</p>
        </div>
        <GlobalSettingsPanel />
        <GlobalDocsPanel />
      </div>
    </div>
  );
}
